import React, { useEffect, useState } from 'react';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import AlertInfo from '@components/obsolete/Alert/AlertInfo.tsx';
import { MessageResponse, ScopeEnum } from '@api/ringil-api.v2.tsx';
import { formatBEValidationMessage } from '@hooks/useBEValidation/formatBEValidationMessage';

interface ValidationMessage extends MessageResponse {}

interface BackendValidationProps {
  validationMessageFilter?: (error: ValidationMessage) => boolean;
}

const useBEValidation = (onValidationError: () => void = () => {}) => {
  const { tr } = useTranslationLgs();
  const [beValidationErrors, setBeValidationErrors] = useState<ValidationMessage[]>([]);

  const clear = () => {
    setBeValidationErrors([]);
  };

  useEffect(() => {
    if (beValidationErrors?.length > 0) {
      onValidationError();
    }
  }, [beValidationErrors]);

  const BackendValidationComponent = ({
                                        validationMessageFilter,
                                      }: BackendValidationProps) => {

    const filteredErrors = validationMessageFilter
      ? beValidationErrors.filter(validationMessageFilter)
      : beValidationErrors;

    return (
      <>
        {filteredErrors && filteredErrors.length > 0 && (
          <AlertInfo backgroundWrapper={'red'}>
            <ul>
              {filteredErrors.map((error, index) => (
                <li key={index} className={'beValidationItem'}>
                  {formatBEValidationMessage(error, tr)}
                </li>
              ))}
            </ul>
          </AlertInfo>
        )}
      </>
    );
  };

  const findFieldError = (path: string): string | undefined => {
    const error = beValidationErrors.find(e => e.scope === ScopeEnum.FIELD && e.path === path);
    if (!error) return undefined;
    return formatBEValidationMessage(error, tr);
  };

  return {
    beValidationErrors,
    setBeValidationErrors,
    BackendValidationComponent,
    findFieldError,
    clear,
  };
};

export default useBEValidation;
